<pr-form
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
>
  <div>
    <h3 class="drawer-title">Biens financiers</h3>
    <div>
      @for (category of categories; track category) {
        <div [class.expanded]="isCategoryExpanded(category.id)">
          <ul>
            <!-- En-tête de catégorie -->
            <li
              class="pointer choose-button"
              (click)="selectCategory(category)"
              [attr.aria-expanded]="isCategoryExpanded(category.id)"
              [attr.aria-controls]="'category-content-' + category.id"
            >
              {{ category.label }}
            </li>
            <!-- type d'asset -->
            @if (
              isCategoryExpanded(category.id) &&
              selectedCategoryOptions.length > 0
            ) {
              @for (assetType of selectedCategoryOptions; track assetType) {
                <li
                  class="pointer choose-button asset-type"
                  [ngClass]="{ up: animatingOptions }"
                  (click)="selectAssetType(assetType)"
                >
                  {{ assetType.label }}
                </li>
              }
            }
          </ul>
        </div>
      }
    </div>
  </div>
</pr-form>
